import { useTranslation } from 'react-i18next'
import { Skeleton } from 'components/UnvUI'

import { fmtDate } from '../../utils/fmtDate'
import styles from './StatementDrawer.module.scss'

const StatementDrawer = ({
  drawer,
  rows,
  drawerLoading,
  onClose,
  updateRow,
  onSaveRows,
  onSign,
  onDownloadPdf,
  onCloseStatement,
}) => {
  const { t } = useTranslation('common')

  return (
    <div className={styles.drawerOverlay} onClick={onClose}>
      <div className={`unv-card ${styles.drawer}`} onClick={(e) => e.stopPropagation()}>
        <div className={styles.drawerHeader}>
          <div>
            <h2>
              {t('statementsPage.statementCard')} ·{' '}
              {drawer.subject_name || drawer.subject?.name || ''}
            </h2>
            <div className={styles.muted}>
              {t('statementsPage.group')} {drawer.group_name || drawer.group?.name || '—'} ·{' '}
              {t('statementsPage.status')}: <span className="unv-badge">{drawer.status}</span>
            </div>
          </div>
          <button className="unv-btn unv-btn--ghost" onClick={onClose}>
            {t('statementsPage.close')}
          </button>
        </div>

        <div className={styles.signers}>
          {(drawer.signatures || drawer.signs || []).map((sg, i) => (
            <div key={i} className={styles.signer}>
              <span className="unv-badge">{sg.role || t('statementsPage.signer')}</span>{' '}
              {sg.user_name || sg.user?.full_name || '—'} ·{' '}
              <span className={styles.muted}>{fmtDate(sg.signed_at)}</span>
            </div>
          ))}
        </div>

        {drawerLoading ? (
          <div className={styles.loaderWrap}>
            <Skeleton variant="text" lines={4} />
          </div>
        ) : (
          <div className={styles.drawerBody}>
            <table className="unv-table">
              <thead>
                <tr>
                  <th>{t('statementsPage.student')}</th>
                  <th>{t('statementsPage.grade')}</th>
                  <th>{t('statementsPage.pass')}</th>
                  <th>{t('statementsPage.absent')}</th>
                </tr>
              </thead>
              <tbody>
                {rows.map((r, idx) => (
                  <tr key={r.id || idx}>
                    <td>{r.studentName || `#${r.student}`}</td>
                    <td>
                      <input
                        type="number"
                        className="unv-input"
                        value={r.grade}
                        onChange={(e) => updateRow(idx, { grade: e.target.value })}
                      />
                    </td>
                    <td>
                      <select
                        className="unv-input"
                        value={r.pass || ''}
                        onChange={(e) => updateRow(idx, { pass: e.target.value })}
                      >
                        <option value="">—</option>
                        <option value="passed">{t('statementsPage.passed')}</option>
                        <option value="failed">{t('statementsPage.failed')}</option>
                      </select>
                    </td>
                    <td>
                      <input
                        type="checkbox"
                        checked={!!r.absent}
                        onChange={(e) => updateRow(idx, { absent: e.target.checked })}
                      />
                    </td>
                  </tr>
                ))}
                {rows.length === 0 && (
                  <tr>
                    <td colSpan="4" className={styles.empty}>{t('statementsPage.noStudents')}</td>
                  </tr>
                )}
              </tbody>
            </table>

            <div className={styles.drawerActions}>
              <button className="unv-btn unv-btn--ghost" onClick={onSaveRows}>
                {t('statementsPage.saveRows')}
              </button>
              <button className="unv-btn unv-btn--ghost" onClick={onSign}>
                {t('statementsPage.sign')}
              </button>
              <button className="unv-btn unv-btn--ghost" onClick={onDownloadPdf}>
                {t('statements.list.download_pdf')}
              </button>
              <button className="unv-btn" onClick={onCloseStatement}>
                {t('statementsPage.closeStatement')}
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  )
}

export default StatementDrawer
